import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { Router } from '@angular/router';
import { CartService } from '../demo/service/cart.service';
import { Profile } from '../demo/models/profile';
import { AuthService } from '../demo/service/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../demo/service/language.service';
import { languages } from '../demo/constants/languages';
import { DropdownChangeEvent } from 'primeng/dropdown';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
})
export class AppTopbarComponent implements OnInit {
    @ViewChild('menubutton') menuButton!: ElementRef;
    userProfile!: any;
    languages: any = languages;
    selectedLanguage!: any;

    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    constructor(public layoutService: LayoutService, public el: ElementRef, private translateService: TranslateService, private languageService: LanguageService, private router: Router, private authService: AuthService, private cartService: CartService) { }

    ngOnInit(): void {
        this.fetchUserProfile();
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }

    languageChanged(event: DropdownChangeEvent) {
        this.setLanguage(event.value);
    }

    fetchUserProfile() {
        this.userProfile = this.authService.getProfile();
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showRightMenu();
    }

    onSearchClick() {
        this.layoutService.toggleSearchBar();
    }

    onRightMenuClick() {
        this.layoutService.showRightMenu();
    }

    onLogout() {
        this.authService.logout();
        this.router.navigate(['/']);
    }

    get logo() {
        const logo =
            this.layoutService.config().menuTheme === 'white' ||
                this.layoutService.config().menuTheme === 'orange'
                ? 'dark'
                : 'white';
        return logo;
    }
}
